import { clearSessions } from "../utils/auth.js";

let spotifyPlayer;
let playerStarted = false;
let continuous_play = true;

export const init = async (patch, audioPlayer) => {
  spotifyPlayer = new Spotify.Player({
    name: 'Sonikit',
    getOAuthToken: cb => { cb(audioPlayer.access_token); }
  });

  await spotifyPlayer.connect();
  
  spotifyPlayer.on('initialization_error', ({ message }) => {
    console.log('Initialize error: ', message);
  });
  spotifyPlayer.on('authentication_error', ({ message }) => {
    clearSessions()
    console.log('Authentication error: ', message);
  });
  spotifyPlayer.on('account_error', ({ message }) => {
    console.log('Account error: ', message);
  });
  spotifyPlayer.on('playback_error', ({ message }) => {
    console.error('Failed to perform playback', message);
  });

  spotifyPlayer.addListener('autoplay_failed', () => {
    console.log('Autoplay is not allowed by the browser autoplay rules');
  });

  
  spotifyPlayer.on('player_state_changed', async state => {
    if (!state) {
      return
    }

    if (!continuous_play && !state.paused) {
      spotifyPlayer.pause();
    }

    if (state.shuffle) {
      await disableShuffle();
    }

    if (state.repeat_mode !== 0) {
      await disableRepeat();
    }

    const volume = await spotifyPlayer.getVolume()
    if (volume !== 1) {
      spotifyPlayer.setVolume(1).then(() => {
        //console.log('volume updated')
      })
    }
    
    if (!playerStarted && state.paused && !state.loading) {
      playerStarted = true;
    } else if (!playerStarted && !state.paused && !state.loading && state.disallows.resuming) {
      playerStarted = true;
      if (!patch.autoplay) {
        spotifyPlayer.pause();
      }
    }


    let playbackState;
    if (state.paused) {
      playbackState = 'paused';
    } else {
      playbackState = 'playing';


      // state.disallows.seeking this determines if the player can seek to time

      if (audioPlayer.currentTrack.id !== state.track_window.current_track.id) {
        // Track changed
        const spotifyArtists = state.track_window.current_track.artists.map(x => x.name).join(", ");
        
        const track = {
          id: state.track_window.current_track.id,
          artist: spotifyArtists,
          title: state.track_window.current_track.name,
          image_url: state.track_window.current_track.album.images[0].url
        }
        
        audioPlayer.updateTrack(track);

        // Restart stream timer with new track
        audioPlayer.startTimer();
      }
    }
    
    audioPlayer.setState(playbackState);
  });

  spotifyPlayer.on('ready', async data => {
    audioPlayer.setDeviceId(data.device_id);
    sonikit.emit('playerReady', { service: 'spotify' });
  });

  return spotifyPlayer;
}

export const forceStop = () => {
  continuous_play = false;
}

export const start = async (audioPlayer, track_index, current_time) => {
  if (!track_index) {
    track_index = 0;
  }

  if (!current_time) {
    current_time = 0;
  }

  if (!continuous_play) {
    continuous_play = true;
    //console.log('restarted continous play')
  }

  const uri = `spotify:${audioPlayer.service.media_type}:${audioPlayer.service.media_id}`
  const body = { context_uri: uri, offset: { position: track_index }, position_ms: current_time };

  const response = await fetch(`https://api.spotify.com/v1/me/player/play?device_id=${audioPlayer.deviceId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${audioPlayer.access_token}`
    },
    body: JSON.stringify(body)
  })

  if (!response.ok) {
    const data = await response.json()
    clearSessions()
    return {status: 'failed'}
  }

  return {status: 'success'}
}

const disableShuffle = async () => {
  try {
    const response = await fetch(`https://api.spotify.com/v1/me/player/shuffle?state=false`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${audioPlayer.access_token}`
      },
      body: JSON.stringify(body)
    })

    if (!response.ok) {
      //console.log('error disabling shuffle')
      return {status: 'failed'}
    }
    
    return {status: 'success'}
  } catch (error) {
    //console.log('error disabling shuffle')
  }
}

const disableRepeat = async () => {
  try {
    const response = await fetch(`https://api.spotify.com/v1/me/player/repeat?state=off`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${audioPlayer.access_token}`
      },
      body: JSON.stringify(body)
    })

    if (!response.ok) {
      //console.log('error disabling repeat')
      return {status: 'failed'}
    }
    
    return {status: 'success'}
  } catch (error) {
    console.log('error disabling repeat')
  }
}